import { useLocation } from 'react-router'
import { useMediaQuery } from 'usehooks-ts'

import appDefaults from '~/app.defaults.json'
import { TopBarDesktop } from '~/components/ConsumerTopBar/desktop'
import { TopBarMobile } from '~/components/ConsumerTopBar/mobile'
import { LandingProduct } from '~/types/product'
import { UserInfo } from '~/types/user'

export interface TopBarProps {
  accentColor?: string,
  logo?: string,
  name?: string,
  user?: UserInfo,
  baseUrl?: string,
  fontFamily?: string,
  currentProduct?: LandingProduct,
  products?: Array<LandingProduct>,
  accentDivider?: boolean,
  disabled?: boolean,
  toggleSideNavWithTransition?: (value: boolean) => void,
}

export const TopBar = ({
  logo,
  accentColor,
  fontFamily,
  user,
  name,
  currentProduct,
  disabled,
  toggleSideNavWithTransition,
  products,
}: TopBarProps) => {

  const isMobile = useMediaQuery(appDefaults.media.mobile, { initializeWithValue: false })
  const { pathname } = useLocation()

  const isLandingPage = pathname === '/'

  return (
    <>
      {isMobile ? (
        <TopBarMobile
          logo={logo}
          accentColor={accentColor}
          fontFamily={fontFamily}
          user={user}
          accentDivider={isLandingPage}
          name={name}
          currentProduct={currentProduct}
          disabled={disabled}
          toggleSideNavWithTransition={toggleSideNavWithTransition}
          products={products}
        />
      ) : (
        <TopBarDesktop
          logo={logo}
          accentColor={accentColor}
          user={user}
          fontFamily={fontFamily}
          accentDivider={isLandingPage}
          name={name}
          currentProduct={currentProduct}
          products={products}
          disabled={disabled}
        />
      )}
    </>
  )
}